export const encodePathKey = key => {
  return encodeURIComponent(key).replace('.', '%2E')
}

export const decodePathKey = key => {
  return decodeURIComponent(key)
}
